var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],ref:_vm.uid,staticClass:"pb-0 mb-1 ml-2 mr-2 pa-1",attrs:{"tabindex":"-1"},domProps:{"textContent":_vm._s(_vm.description)}})
}
var staticRenderFns = []

export { render, staticRenderFns }